<template>
   <Transition name="confirm-modal-fade">
      <div v-if="isOpen" class="confirm-modal-overlay" @click.self="onCancel">
         <div class="confirm-modal">
            <div class="confirm-modal__header">
               <h5 class="confirm-modal__title">{{ title }}</h5>
               <button @click="onCancel" class="confirm-modal__close">&times;</button>
            </div>
            <div class="confirm-modal__divider"></div>
            <div class="confirm-modal__body">
               <p class="confirm-modal__message">{{ message }}</p>
            </div>
            <div class="confirm-modal__footer">
               <button type="button" class="confirm-modal__btn confirm-modal__btn--cancel" @click="onCancel">
                  {{ cancelText }}
               </button>
               <button type="button" class="confirm-modal__btn confirm-modal__btn--confirm" @click="onConfirm">
                  {{ confirmText }}
               </button>
            </div>
         </div>
      </div>
   </Transition>
</template>

<script>
export default {
   name: 'ConfirmModal',
   props: {
      modelValue: {
         type: Boolean,
         default: false,
      },
      title: {
         type: String,
         default: 'Confirm Action',
      },
      message: {
         type: String,
         default: 'Are you sure you want to proceed?',
      },
      confirmText: {
         type: String,
         default: 'Yes',
      },
      cancelText: {
         type: String,
         default: 'No',
      },
   },
   emits: ['update:modelValue', 'confirm', 'cancel'],
   computed: {
      isOpen() {
         return this.modelValue;
      },
   },
   methods: {
      onConfirm() {
         this.$emit('confirm');
         this.$emit('update:modelValue', false);
      },
      onCancel() {
         this.$emit('cancel');
         this.$emit('update:modelValue', false);
      },
   },
};
</script>

<style>
/* ═══════════════════════════════════════════════════════════
   CONFIRM MODAL — Global Styles (not scoped so it works everywhere)
   Matches the BDM Dashboard modal design language
   ═══════════════════════════════════════════════════════════ */

/* Fade transition */
.confirm-modal-fade-enter-active,
.confirm-modal-fade-leave-active {
   transition: opacity 0.25s ease;
}
.confirm-modal-fade-enter-active .confirm-modal,
.confirm-modal-fade-leave-active .confirm-modal {
   transition: transform 0.25s ease, opacity 0.25s ease;
}
.confirm-modal-fade-enter-from,
.confirm-modal-fade-leave-to {
   opacity: 0;
}
.confirm-modal-fade-enter-from .confirm-modal,
.confirm-modal-fade-leave-to .confirm-modal {
   transform: scale(0.95) translateY(-10px);
   opacity: 0;
}

/* Overlay */
.confirm-modal-overlay {
   position: fixed;
   top: 0;
   left: 0;
   width: 100vw;
   height: 100vh;
   background-color: rgba(0, 0, 0, 0.5);
   display: flex;
   justify-content: center;
   align-items: center;
   z-index: 20000;
}

/* Modal container */
.confirm-modal {
   position: relative;
   background-color: #fff;
   border-radius: 16px;
   width: 100%;
   max-width: 440px;
   box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
   overflow: hidden;
}

/* Header */
.confirm-modal__header {
   display: flex;
   align-items: center;
   justify-content: space-between;
   padding: 1.5rem 2rem 0 2rem;
}

.confirm-modal__title {
   font-weight: 700;
   font-size: 1.15rem;
   color: #1e293b;
   margin: 0;
}

.confirm-modal__close {
   font-size: 1.8rem;
   font-weight: bold;
   line-height: 1;
   color: #94a3b8;
   background: none;
   border: none;
   cursor: pointer;
   padding: 0;
   transition: color 0.2s ease;
}

.confirm-modal__close:hover {
   color: #1e293b;
}

/* Divider */
.confirm-modal__divider {
   height: 1px;
   background-color: #e2e8f0;
   margin: 1rem 2rem 0 2rem;
}

/* Body */
.confirm-modal__body {
   padding: 1.5rem 2rem;
}

.confirm-modal__message {
   font-size: 0.95rem;
   color: #475569;
   line-height: 1.6;
   margin: 0;
   text-align: center;
   white-space: pre-line;
}

/* Footer */
.confirm-modal__footer {
   display: flex;
   align-items: center;
   justify-content: flex-end;
   gap: 12px;
   padding: 0 2rem 1.5rem 2rem;
   border-top: 1px solid #f1f5f9;
   padding-top: 1rem;
}

/* Buttons */
.confirm-modal__btn {
   padding: 8px 28px;
   font-size: 0.9rem;
   font-weight: 600;
   border-radius: 8px;
   cursor: pointer;
   transition: all 0.2s ease;
   border: none;
}

.confirm-modal__btn--cancel {
   background-color: #f1f5f9;
   color: #475569;
   border: 1px solid #e2e8f0;
}

.confirm-modal__btn--cancel:hover {
   background-color: #e2e8f0;
   color: #1e293b;
}

.confirm-modal__btn--confirm {
   background-color: #00A0C1;
   color: #fff;
}

.confirm-modal__btn--confirm:hover {
   background-color: #008da8;
   box-shadow: 0 4px 12px rgba(0, 160, 193, 0.3);
}
</style>
